
import styled,{css} from "styled-components";
import { Controller } from 'react-hook-form';

const TextAreaFormInput = ({
  name,
  rows = 3,
  containerClassName,
  control,
  id,
  labelClassName,
  label,
  areaWidth,
  ...other
}) => {
  return (
    <Controller
      name={name}
      defaultValue={''}
      control={control}
      render={({ field }) => (
        <FormGroup className={containerClassName ?? ''} width={areaWidth}>
          {label && <FormLabel className={labelClassName}>{label}</FormLabel>}
          <FormControl id={id} rows={rows} {...other} {...field} />
        </FormGroup>
      )}
    />
  );
};

export default TextAreaFormInput;


const FormGroup = styled.div `
display: block;
width: ${(props) => props.width ?  css`calc(${props.width} - 20px)` : "100%"};

`
const FormLabel = styled.label `
display: block;
color: ${({ theme }) => theme.color};
font-size: 14px;
margin-bottom: 8px;
`

const FormControl = styled.textarea `
width: 100%;
border-radius: 8px;
border: ${({ theme }) => `1px solid ${theme.cardStroke}`};
background-color: ${({ theme }) => theme.inputbg};
color: ${({ theme }) => theme.color};
padding: 2px 6px;
box-sizing: border-box;
`